import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HelpCenterSection = ({ section, expanded, onToggle }) => {
  const { t } = useTranslation("common");

  return (
    <article className={`help-center-section${expanded ? " expanded" : ""}`} id={section.id}>
      <button type="button" className="help-center-section-header" onClick={onToggle}>
        <span className="help-center-section-title">{t(section.titleKey)}</span>
        <span className="help-center-section-chevron" aria-hidden="true">
          {expanded ? "−" : "+"}
        </span>
      </button>

      {expanded ? (
        <div className="help-center-section-body">
          <p className="help-center-overview">{t(section.overviewKey)}</p>

          <div className="help-center-block">
            <h3>{t("helpCenter.common.features")}</h3>
            <ul>
              {section.featureKeys.map((key) => (
                <li key={key}>{t(key)}</li>
              ))}
            </ul>
          </div>

          <div className="help-center-block">
            <h3>{t("helpCenter.common.steps")}</h3>
            <ol>
              {section.stepKeys.map((key) => (
                <li key={key}>{t(key)}</li>
              ))}
            </ol>
          </div>

          {section.noteKeys?.length ? (
            <div className="help-center-block help-center-notes">
              <h3>{t("helpCenter.common.notes")}</h3>
              <ul>
                {section.noteKeys.map((key) => (
                  <li key={key}>{t(key)}</li>
                ))}
              </ul>
            </div>
          ) : null}

          <Link to={section.path} className="btn btn-ghost btn-sm help-center-go-link">
            {t("helpCenter.common.openSection")}
          </Link>
        </div>
      ) : null}
    </article>
  );
};

HelpCenterSection.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    titleKey: PropTypes.string.isRequired,
    overviewKey: PropTypes.string.isRequired,
    featureKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    stepKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    noteKeys: PropTypes.arrayOf(PropTypes.string),
    path: PropTypes.string.isRequired
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default HelpCenterSection;
